export default {

    props  : {

        scopeduser : {

            type     : Object,
            default  : null,
            required : false
        }
    },

    data(){


    },

    computed: {


    },

    methods: {

    },

    watch: {

    },

    created(){


    },

    mounted(){

        if( this.scopeduser && this.scopeduser.id ) this.addUser( this.scopeduser );
    }
}